import React, { useState, useEffect } from "react";
import { fetchMaster } from "../../../utils/api";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TableSortLabel,
  Skeleton,
} from "@mui/material";
import styleClass from "./LowActivityMerchantDataLake.module.scss";
import moment from "moment";

const LowActivityMerchantDataLake = () => {
  const [merchantInfo, setMerchantInfo] = useState([]);
  const [lastModifiedDateTime, setLastModifiedDateTime] = useState(" ");
  const [isLoading, setIsLoading] = useState(true);

  const initialFetch = async () => {
    const merchantInfoPromise = fetchMaster("/data-lake-report/get-latest-report", {
      reportType: "low-activity-merchant-list"
    });

    Promise.all([merchantInfoPromise])
      .then(([merchantInfoResponse]) => {
        setIsLoading(false);
        if (merchantInfoResponse.message === "SUCCESS") {
          setMerchantInfo(merchantInfoResponse.data);
          setLastModifiedDateTime(merchantInfoResponse.lastModifiedDateTime)
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setIsLoading(false);
        // Handle errors here
      });
    return;
  };

  useEffect(() => {
    const init = async () => {
      await initialFetch();
    };
    init();
  }, []);

  const tableColumns = [
    {
      title: "*Merchant ID",
      dataIndex: "Merchant ID",
      sorter: true,
      width: 150,
    },
    {
      title: "Merchant Legal Name",
      dataIndex: "Merchant Legal Name",
      width: 100,
    },
    {
      title: "Merchant DBA Name",
      dataIndex: "Merchant DBA Name",
      width: 100,
    },
    {
      title: "Last Transaction Date",
      dataIndex: "Last Transaction Day",
      width: 200,
    },
    {
      title: "*Transaction Amount",
      dataIndex: "Transaction Amount",
      sorter: true,
      width: 200,
    },
  ];

  const TableRowsLoader = ({ rowsNum, columns }) => {
    return [...Array(rowsNum)].map((row, index) => (
      <TableRow key={index}>
        {Object.keys(columns).map(() => {
          return (
            <TableCell component="th" scope="row" key={index}>
              <Skeleton animation="wave" variant="text" />
            </TableCell>
          )
        })}
      </TableRow>
    ));
  };

  const renderTableContent = (sortedData, columns) => {
    if (isLoading) {
      return (<TableRowsLoader rowsNum={10} columns={columns} />)
    } else {
      return (
        sortedData.map((row, index) => (
          <TableRow key={index}>
            {columns.map((column) => (
              <TableCell key={column.dataIndex}>
                {column.render
                  ? column.render(row[column.dataIndex])
                  : row[column.dataIndex]}
              </TableCell>
            ))}
          </TableRow>
        ))
      );
    }
  }

  const renderScrollableTable = (columns, data) => {
    const [sortConfig, setSortConfig] = useState({
      key: "merchantId",
      direction: "asc",
    });
    const handleSort = (key) => {
      const direction =
        sortConfig.key === key && sortConfig.direction === "asc"
          ? "desc"
          : "asc";
      setSortConfig({ key, direction });
    };
    const sortedData = data.sort((a, b) => {
      if (sortConfig.direction === "asc") {
        return parseInt(a[sortConfig.key]) >= parseInt(b[sortConfig.key])
          ? 1
          : -1;
      } else {
        return parseInt(a[sortConfig.key]) < parseInt(b[sortConfig.key])
          ? 1
          : -1;
      }
    });
    return (
      <TableContainer component={Paper}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.dataIndex}
                  style={{ minWidth: column.width }}
                >
                  {column.sorter ? (
                    <TableSortLabel
                      active={sortConfig.key === column.dataIndex}
                      direction={
                        sortConfig.key === column.dataIndex
                          ? sortConfig.direction
                          : "asc"
                      }
                      onClick={() => handleSort(column.dataIndex)}
                      hideSortIcon={false}
                    >
                      {column.title}
                    </TableSortLabel>
                  ) : (
                    column.title
                  )}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {renderTableContent(sortedData, columns)}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  return (
    <div style={{ padding: "24px" }}>
      <div className={styleClass.lastModifiedDateTime}>Last Updated: {moment(lastModifiedDateTime).format("YYYY-MM-DD HH:mm:ss")}</div>
      {renderScrollableTable(tableColumns, merchantInfo)}
    </div>
  );
};

export default LowActivityMerchantDataLake;
